import React from 'react'



const CTA = () => {
  return (
    <div className='cta'>
        <a href="#treatments" className='btn'>View Services</a>
        <a href="#contact" className='btn btn-primary'>Book Now</a>
    </div>
  )
}

export default CTA